import { AddLocationComponent } from "./add-location/add-location.component";
import { EditLocationComponent } from "./edit-location/edit-location.component";
import { ViewLocationComponent } from "./view-location/view-location.component";


export const LocationDeclaration = [
    ViewLocationComponent,
    AddLocationComponent,
    EditLocationComponent,
];